module.exports = __webpack_public_path__ + "img/flt_pt_slt_setsku.prt.013650a5.jpg";